/**
  * 专题选择匠人 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const specialtrad = {
    // 列表
    list (params) {
        return axios.get(api + 'specialtrad/list',{params:params})
    },
    //添加
    create (params) {
        return axios.post(api + 'specialtrad/create',qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'specialtrad/detail',{params:params})
    },
    sort (params) {
        return axios.post(api + 'specialtrad/sort',qs.stringify(params))
    }
}


// 导出接口
export default specialtrad